export default "__VITE_ASSET__BfqYSqAs__"